import { api } from "@/lib/api"

/**
 * LA PISTA DE AUDITORIA. Modulo `audit` del backend.
 *
 *   GET /api/auditoria           ?tabla&accion&registro_id&usuario&desde&hasta&solo_con_motivo&limite
 *   GET /api/auditoria/resumen   ?dias
 *   GET /api/auditoria/historia/{tabla}/{registro_id}
 *
 * Solo la ven auditor, contador y administrador de plataforma — no se abre con
 * permiso de lectura, porque contiene los valores ANTERIORES de todo lo que se
 * edito. Un 403 aqui es correcto y la pantalla lo explica.
 */

export interface CambioDeCampo {
  campo: string
  antes: unknown
  despues: unknown
  /** `true` = el valor no se publica (clave, token). El CAMBIO sí se ve. */
  valor_oculto?: boolean | null
  es_alta: boolean
  es_baja: boolean
}

export interface EntradaDePista {
  id: string
  cuando: string
  accion: string
  tabla: string
  registro_id: string | null
  autor: string | null
  autor_email: string | null
  /** `true` = lo escribió un proceso de servicio, no una persona. */
  sin_autor: boolean
  motivo: string | null
  cambios: CambioDeCampo[]
}

export interface Pista {
  entradas: EntradaDePista[]
  total_devuelto: number
  tope: number
  hay_mas: boolean
  nota: string
}

export interface ResumenDeAuditoria {
  dias: number
  total: number
  sin_autor: number
  denegados: number
  por_tabla: Array<{
    tabla: string
    accion: string
    n: number
    sin_autor: number
    con_motivo: number
  }>
  por_autor: Array<{ autor: string; email: string | null; n: number }>
  advertencias: Array<{ clave: string; grave: boolean; texto: string }>
}

export interface FiltrosDePista {
  tabla?: string
  accion?: string
  usuario?: string
  desde?: string
  hasta?: string
  soloConMotivo?: boolean
  limite?: number
}

export function fetchPista(f: FiltrosDePista): Promise<Pista> {
  const q = new URLSearchParams()
  if (f.tabla) q.set("tabla", f.tabla)
  if (f.accion) q.set("accion", f.accion)
  if (f.usuario) q.set("usuario", f.usuario)
  if (f.desde) q.set("desde", f.desde)
  if (f.hasta) q.set("hasta", f.hasta)
  if (f.soloConMotivo) q.set("solo_con_motivo", "true")
  q.set("limite", String(f.limite ?? 100))
  return api.get<Pista>(`/auditoria?${q.toString()}`)
}

export function fetchResumen(dias: number): Promise<ResumenDeAuditoria> {
  return api.get<ResumenDeAuditoria>(`/auditoria/resumen?dias=${dias}`)
}
